<template>
    <div class="json-editor-wrapper jse-theme-dark" :class="validateError != '' ? 'box-border-color' : ''" :style="{ height: height }">
        <div ref="editorContainer" class="json-editor-inner"></div>
        <span class="invalid-feedback-custom" v-show="validateError" v-html="validateError" />
    </div>
</template>

<script>
import { createJSONEditor } from 'vanilla-jsoneditor/standalone.js'
import 'vanilla-jsoneditor/themes/jse-theme-dark.css'

export default {
    name: 'JsonEditor',
    props: {
        value: {
            default: () => ({})
        },
        mode: {
            type: String,
            default: 'tree'
        },
        stringified: {
            type: Boolean,
            default: true
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: '420px'
        },
        mainMenuBar: {
            type: Boolean,
            default: true
        },
        navigationBar: {
            type: Boolean,
            default: true
        },
        statusBar: {
            type: Boolean,
            default: true
        },
        validateError: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            editor: null,
            internalUpdating: false
        }
    },
    mounted() {
        this.initEditor()
    },
    beforeDestroy() {
        if (this.editor) {
            this.editor.destroy()
            this.editor = null
        }
    },
    watch: {
        value(newVal) {
            if (this.internalUpdating) return
            if (this.editor) {
                const content = this.getContent(newVal)
                this.editor.set(content)
            }
        },
        mode(newMode) {
            if (this.editor) {
                this.editor.updateProps({ mode: newMode })
            }
        },
        readOnly(newReadOnly) {
            if (this.editor) {
                this.editor.updateProps({ readOnly: newReadOnly })
            }
        }
    },
    methods: {
        getContent(val) {
            if (val === null || val === undefined || val === '') {
                return { json: {} }
            }
            if (typeof val === 'string') {
                try {
                    return { json: JSON.parse(val) }
                } catch (e) {
                    return { text: val }
                }
            }
            if (typeof val === 'object') {
                return { json: val }
            }
            return { text: String(val) }
        },
        initEditor() {
            if (!this.$refs.editorContainer) return
            const content = this.getContent(this.value)

            this.editor = createJSONEditor({
                target: this.$refs.editorContainer,
                props: {
                    content,
                    mode: this.mode,
                    readOnly: this.readOnly,
                    mainMenuBar: this.mainMenuBar,
                    navigationBar: this.navigationBar,
                    statusBar: this.statusBar,
                    indentation: 2,
                    onChange: (updatedContent) => {
                        this.handleChange(updatedContent)
                    }
                }
            })
        },
        handleChange(content) {
            let output
            if (content.json !== undefined) {
                output = this.stringified ? JSON.stringify(content.json) : content.json
            } else if (content.text !== undefined) {
                output = content.text
            }

            this.internalUpdating = true
            this.$emit('input', output)
            this.$emit('change', output)
            this.$nextTick(() => {
                this.internalUpdating = false
            })
        }
    }
}
</script>

<style scoped>
.json-editor-wrapper {
    width: 100%;
    border: 1px solid #3c3c3c;
    border-radius: 6px;
    overflow: hidden;
    background-color: #1e1e1e;
    position: relative;
    display: flex;
    flex-direction: column;
}

.json-editor-inner {
    height: 100%;
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
}

.json-editor-wrapper >>> .jse-main {
    height: 100% !important;
    min-height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
}

.json-editor-wrapper >>> .jse-contents {
    flex: 1 1 auto !important;
    height: auto !important;
    min-height: 0 !important;
    overflow-y: auto !important;
    overflow-x: auto !important;
}

.json-editor-wrapper >>> .jse-tree {
    overflow-y: auto !important;
    height: 100% !important;
}

.json-editor-wrapper >>> .cm-editor,
.json-editor-wrapper >>> .cm-scroller {
    height: 100% !important;
    overflow: auto !important;
}

.json-editor-wrapper.box-border-color {
    border-color: #dc3545;
}
</style>
